import { ExternalLink } from "lucide-react";

const short = (u) => (u || "").replace(/^https?:\/\/(www\.)?entrancezone\.com\//, "/").replace(/\/$/, "") || "(direct)";

export function SourceReport({ data }) {
  if (!data) return <div className="h-32 animate-pulse rounded-xl bg-secondary" />;
  return (
    <div className="rounded-xl border bg-card" data-testid="source-report">
      <div className="flex items-baseline justify-between px-4 pt-4">
        <div className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">Which articles convert · last {data.days} days</div>
        <div className="text-xs text-muted-foreground" data-testid="source-count">{data.total_sources} source pages</div>
      </div>
      {data.items.length === 0 ? <p className="px-4 pb-4 pt-2 text-sm text-muted-foreground" data-testid="source-empty">No subscriptions in this range yet.</p> : (
        <div className="overflow-x-auto p-2">
          <table className="w-full text-sm">
            <thead className="text-left text-[11px] font-mono uppercase tracking-widest text-muted-foreground">
              <tr><th className="px-2 py-1.5">Article / post</th><th className="px-2 py-1.5 text-right">Subs</th><th className="px-2 py-1.5 text-right">Completed</th><th className="px-2 py-1.5 text-right">AI attempts</th><th className="px-2 py-1.5 text-right">AI connected</th><th className="px-2 py-1.5 text-right">AI rate</th><th className="px-2 py-1.5 text-right">Assess. done</th></tr>
            </thead>
            <tbody>
              {data.items.map((r) => (
                <tr key={r.page_url} className="border-t" data-testid={`source-row-${r.post_id || "direct"}`}>
                  <td className="max-w-md px-2 py-1.5">
                    <div className="truncate font-medium">{r.page_title || short(r.page_url)}</div>
                    <div className="flex items-center gap-1 truncate text-[11px] text-muted-foreground">{short(r.page_url)}{r.page_url?.startsWith("http") && <a href={r.page_url} target="_blank" rel="noreferrer" className="hover:text-foreground"><ExternalLink className="h-3 w-3" /></a>}{r.post_id && <span>· #{r.post_id}</span>}</div>
                  </td>
                  <td className="px-2 py-1.5 text-right font-mono">{r.subscriptions}</td>
                  <td className="px-2 py-1.5 text-right font-mono">{r.completed}</td>
                  <td className="px-2 py-1.5 text-right font-mono">{r.ai_attempts}</td>
                  <td className="px-2 py-1.5 text-right font-mono">{r.ai_connected}</td>
                  <td className="px-2 py-1.5 text-right font-mono">{r.ai_rate}%</td>
                  <td className="px-2 py-1.5 text-right font-mono">{r.assessments_completed}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
